<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-md-6">
        <el-form-item label="Тематическая страница" prop="topic_id">
          <el-select
            v-model="form.topic_id"
            filterable
            :loading="topicsLoading"
            placeholder="Выберите тему"
            style="width: 100%"
          >
            <el-option
              v-for="topic in topics"
              :key="topic.id"
              :label="topic.title"
              :value="topic.id"
            />
          </el-select>
          {{ $_ErrorMixin_getError('topic_id') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Город" prop="city_id">
          <el-select
            v-if="cityOptions"
            v-model="form.city_id"
            filterable
            placeholder="Выберите город"
            remote
            :remote-method="getCity"
            reserve-keyword
            style="width: 100%"
          >
            <el-option
              v-for="city in cityOptions"
              :key="city.id"
              :label="city.name"
              :value="city.id"
            />
          </el-select>
          {{ $_ErrorMixin_getError('city_id') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Title (UA)" prop="title">
          <el-input v-model="form.title" />
          {{ $_ErrorMixin_getError('title') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Title (RU)" prop="title_ru">
          <el-input v-model="form.title_ru" />
          {{ $_ErrorMixin_getError('title_ru') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Description (UA)" prop="description">
          <el-input
            v-model="form.description"
            :rows="4"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('description') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Тег Description (RU)" prop="description_ru">
          <el-input
            v-model="form.description_ru"
            :rows="4"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('description_ru') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Заголовок H1 (UA)" prop="h1">
          <el-input v-model="form.h1" />
          {{ $_ErrorMixin_getError('h1') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="Заголовок H1 (RU)" prop="h1_ru">
          <el-input v-model="form.h1_ru" />
          {{ $_ErrorMixin_getError('h1_ru') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="SEO текст (UA)" prop="seo_text">
          <el-input
            v-model="form.seo_text"
            :rows="6"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('seo_text') }}
        </el-form-item>
      </div>

      <div class="col-md-6">
        <el-form-item label="SEO текст (RU)" prop="seo_text_ru">
          <el-input
            v-model="form.seo_text_ru"
            :rows="6"
            type="textarea"
          />
          {{ $_ErrorMixin_getError('seo_text_ru') }}
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ErrorMixin from '@/utils/ErrorMixin'

const defaultValues = {
  topic_id: '',
  city_id: '',
  title: '',
  title_ru: '',
  description: '',
  description_ru: '',
  h1: '',
  h1_ru: '',
  seo_text: '',
  seo_text_ru: '',
}

export default {
  name: 'SeoTopicTemplateForm',
  components: {},
  mixins: [ErrorMixin],
  data() {
    return {
      form: { ...defaultValues },
      rules: {
        topic_id: [
          { required: true, message: 'Пожалуйста, выберите тему', trigger: 'change' },
        ],
        city_id: [
          { required: true, message: 'Пожалуйста, выберите город', trigger: 'change' },
        ],
        title: [],
        title_ru: [],
        description: [],
        description_ru: [],
        h1: [],
        h1_ru: [],
        seo_text: [],
        seo_text_ru: [],
      },
      cityOptions: [],
      topicsLoading: false,
    }
  },
  computed: {
    ...mapState('topics', [
      'topics',
    ]),
    isUpdate() {
      return this.$route.name === 'UpdateSeoTopicTemplate'
    },
  },
  async created() {
    await Promise.all([
      this.getCities(),
      this.getTopics(),
      this.fetchSeoTemplate(),
    ])
  },
  methods: {
    ...mapActions('seoTemplatesTopic', [
      'createSeoTemplate',
      'updateSeoTemplate',
      'getSeoTemplateById',
    ]),
    ...mapActions('cities', [
      'fetchCities',
      'preloadCities',
    ]),
    ...mapActions('topics', ['getAllTopics']),
    async onSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.isUpdate) {
              await this.updateSeoTemplate({formData: this.form, id: this.form.id})
              this.$message.success('SEO шаблон успешно обновлен')
            } else {
              await this.createSeoTemplate(this.form)
              this.$message.success('SEO шаблон успешно создан')
            }

            this.$_ErrorMixin_clearErrors()
            this.$router.push({ name: 'SeoTemplatesTopicList' })
          } catch (error) {
            this.$_ErrorMixin_handleError(error)
          }
        }
      })
    },
    async fetchSeoTemplate() {
      const id = this.$route.params.id
      if (id) {
        const model = await this.getSeoTemplateById(id)
        this.fillForm(model)

        if (model.city) {
          const cityExists = this.cityOptions.some((c) => c.id === model.city.id)
          if (!cityExists) {
            this.cityOptions.unshift(model.city)
          }
        }
      }
    },
    fillForm(model) {
      this.form = {
        ...this.form,
        ...model,
        topic_id: model.topic_id || model.topic?.id || '',
        city_id: model.city_id || model.city?.id || '',
      }
    },
    async getCities() {
      this.cityOptions = await this.preloadCities()
    },
    async getCity(query) {
      if (query !== '') {
        this.cityOptions = await this.fetchCities({ search: query })
      }
    },
    async getTopics() {
      this.topicsLoading = true
      await this.getAllTopics()
      this.topicsLoading = false
    },
  },
}
</script>

<style lang="sass" scoped>
.seo-templates-form__upload-image
  margin-bottom: 10px

.seo-templates-form__preview
  margin-top: 10px
  padding: 10px
  border: 1px solid #dcdfe6
  border-radius: 4px
  display: inline-block

.seo-templates-form__preview-image
  max-width: 200px
  max-height: 200px
  object-fit: contain
</style>


